import { useProfielImage } from "app/hooks/configurator/useProfielImage";
import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";

export const ProfielProductImage = () => {
  const { layout, color } = useConfigurationOptionsContext();

  // Profiel images
  const { imageId, alt } = useProfielImage({
    layoutCode: layout?.code,
    colorCode: color?.code,
  });
  return (
    <div className="gg-container gg-mx-auto gg-h-min gg-px-1">
      {/* Selected profile images */}
      <div className="gg-h-96 gg-w-full sm:gg-h-[33rem] md:gg-h-[39.5rem] md:gg-px-2 lg:gg-h-[30rem] xl:gg-h-[33rem] 2xl:gg-h-[39.5rem]">
        <img
          src={imageId}
          className="gg-h-full gg-w-full gg-object-center"
          alt={alt}
        />
      </div>
    </div>
  );
};
